export enum AttemptDetailsTabEnum {
  QUESTIONS = 'questions',
  TIMELINE = 'timeline',
}
